var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#DFE0E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_287)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E0E3E1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.3889,
    stroke: "#171E26",
    strokeOpacity: 0.2,
    strokeWidth: 1.22222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 22.5903V21.4898C3.6665 17.3836 6.29063 14.0553 9.52764 14.0553H12.472C15.709 14.0553 18.3332 17.3836 18.3332 21.4898V22.5903H3.6665Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9038 3.6665H10.0961C8.23275 3.6665 6.72217 5.22876 6.72217 7.15591C6.72217 9.08306 8.23275 10.6453 10.0961 10.6453H11.9038C13.7671 10.6453 15.2777 9.08306 15.2777 7.15591C15.2777 5.22876 13.7671 3.6665 11.9038 3.6665Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 11.0007C15.0502 11.0007 18.3334 9.90621 18.3334 8.55603C18.3334 7.20586 15.0502 6.11133 11.0001 6.11133C6.94999 6.11133 3.66675 7.20586 3.66675 8.55603C3.66675 9.90621 6.94999 11.0007 11.0001 11.0007Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5504 8.12134H9.44892C7.71402 8.12134 7.37362 8.80525 7.36365 8.92002C7.35369 9.03478 7.33325 9.69897 7.33325 9.86307V10.8238C7.33325 12.9337 8.97445 14.2324 10.9999 14.2324C13.0249 14.2324 14.6666 12.9342 14.6666 10.8238V9.86307C14.6666 9.70157 14.6581 9.0997 14.6362 8.92054C14.6143 8.74138 14.0107 8.12134 12.5504 8.12134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.77783,
    y: 12.2224,
    width: 2.44444,
    height: 3.66667,
    rx: 1.22222,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.31e017da194353ed6fd77a566da0d9ee.svg";
export { ForwardRef as ReactComponent };